module.exports = __webpack_public_path__ + "static/media/instructivooc3.a9bba206.png";